export const LINKEDIN_ACTIVE_SEARCH_PATTERN =
	'(?<url>://www.linkedin.com/search/results/people/\\?)(.*)' +
	'(?<queryString>keywords=[^&]|network=[^&]|facetNetwork=[^&]|geoUrn=[^&]|talksAbout=[^&]|connectionOf=[^&]|followerOf=[^&]' +
	'|currentCompany=[^&]|pastCompany=[^&]|schoolFilter=[^&]|industry=[^&]' +
	'|profileLanguage=[^&]|contactInterest=[^&]|serviceCategory=[^&]|firstName=[^&]|lastName=[^&]|title=[^&]|titleFreeText[^&]|company=[^&]' +
	'|schoolFreetext=[^&]|position=[^&]|activelyHiringForJobTitles=[^&]|eventAttending=[^&]|facetConnectionOf=[^&])'

export const LINKEDIN_GROUP_PATTERN =
	'(?<url>://www\\.linkedin\\.com/groups/.*/members/)'

export const SALES_NAV_SEARCH_PATTERN =
	'(?<url>://www.linkedin.com/sales/search/people)(.*)(?<queryString>query=[^&]|recentSearchId=[^&]|savedSearchId=[^&])'

export const SALES_NAV_LEADS_PATTERN =
	'(?<url>://www.linkedin.com/sales/lists/people/)(.*)'

export const LINKEDIN_EVENT_PATTERN =
	'(?<url>://www.linkedin.com/search/results/people/\\?)(.*)(?<queryString>eventAttending=[^&])'

export function isUrlMatchingPattern(url: string, urlPattern: string): boolean {
	const result = Boolean(new RegExp(urlPattern, 'i').exec(url))
	return result
}

export function isValidLinkedInSearchUrl(url: string): boolean {
	const result = isUrlMatchingPattern(url, LINKEDIN_ACTIVE_SEARCH_PATTERN)
	return result
}

export function isValidLinkedInGroupUrl(url: string): boolean {
	const result = isUrlMatchingPattern(url, LINKEDIN_GROUP_PATTERN)
	return result
}

export function isValidLinkedInEventAttendeesUrl(url: string): boolean {
	const result = isUrlMatchingPattern(url, LINKEDIN_EVENT_PATTERN)
	return result
}

export function isValidSalesNavigatorSearchUrl(url: string): boolean {
	const result = isUrlMatchingPattern(url, SALES_NAV_SEARCH_PATTERN)
	return result
}

export function isValidSalesNavigatorLeadsListUrl(url: string): boolean {
	const result = isUrlMatchingPattern(url, SALES_NAV_LEADS_PATTERN)
	return result
}
